module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('h1', {
    staticClass: "toc_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253059833_Acknowledgments#ack",
      "id": "r_ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253059833_Introduction#intro",
      "id": "r_intro"
    }
  }, [_vm._v("Introduction to the Second Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253059833_Introduction01#intro1",
      "id": "r_intro1"
    }
  }, [_vm._v("Introduction: “"), _c('i', [_vm._v("¡¿Que Haces Gringuito?!")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Part01#part1",
      "id": "r_part1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART")]), _vm._v(" 1. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("HISTORY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter01#ch1",
      "id": "r_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1")]), _c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("Bacon’s Rebellion and the Advent of Whiteness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter02#ch2",
      "id": "r_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2")]), _c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("The Draft Riots of 1863 and the Defense of White Privilege")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Part02#part2",
      "id": "r_part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART")]), _vm._v(" 2. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRAGMATIST TOOLS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter03#ch3",
      "id": "r_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("John Dewey and Inquiry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter04#ch4",
      "id": "r_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("Race as Deweyan Habit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter05#ch5",
      "id": "r_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("Du Bois and the Gift of Race")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter06#ch6",
      "id": "r_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("Du Bois’s Critique of Whiteness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Part03#part3",
      "id": "r_part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART")]), _vm._v(" 3. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CONTEMPORARY PROBLEMS AND DEBATES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter07#ch7",
      "id": "r_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("Whiteness in Post–Civil Rights America")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter08#ch8",
      "id": "r_ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("Contemporary Debates on Whiteness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Part04#part4",
      "id": "r_part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART")]), _vm._v(" 4. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("RECONSTRUCTING WHITENESS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter09#ch9",
      "id": "r_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")]), _c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("Habits of Whiteness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter10#ch10",
      "id": "r_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10")]), _c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("Whiteness Reconstructed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Conclusion#con",
      "id": "r_con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Gifts beyond the Pale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm_ts"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Notes#notes",
      "id": "r_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm_ts"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Bibliography#bib",
      "id": "r_bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm_ts"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253059833_Index#index",
      "id": "r_index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-063361b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253059833_Contents.vue
// module id = 69
// module chunks = 0